import { uniqBy } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
import { get } from "utils/DeApi";

const useFetchAuditFiles = ({
  auditId,
  fetchByDefault = true,
  onSuccess,
  page,
  perPage,
  filters = {},
}) => {
  const subscribedPromises = useRef([]);
  const currentFilters = useRef(filters);
  const initialFetchDone = useRef(false);

  const [files, setFiles] = useState();
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [meta, setMeta] = useState("");

  const onSuccessRef = useRef(onSuccess);
  useEffect(() => {
    onSuccessRef.current = onSuccess;
  }, [onSuccess]);

  const fetchFiles = useCallback(
    (showLoader = true) => {
      setError(null);

      if (showLoader) setIsLoading(true);

      const filePromise = get(`audits/${auditId}/files`, {
        params: {
          sort: "createdAt",
          page: page ?? 1,
          perPage: perPage ?? 10,
          name: currentFilters.current.search || "",
          level: currentFilters.current.level || "",
        },
      });

      subscribedPromises.current.push(filePromise);

      filePromise.promise
        .then(({ data, meta }) => {
          setMeta(meta);
          setFiles(uniqBy(data, "fileId"));
          onSuccessRef.current?.(data);
          initialFetchDone.current = true;
        })
        .catch((error) => {
          if (error?.isCanceled) return;
          setError(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [auditId, page, perPage],
  );

  useEffect(() => {
    if (fetchByDefault) fetchFiles();

    const promises = subscribedPromises.current;
    return () => {
      promises.forEach(function (promise) {
        promise.cancel();
      });
    };
  }, [fetchByDefault, fetchFiles]);

  return {
    error,
    isLoading,
    files,
    setFiles,
    fetchFiles,
    meta,
    initialFetchDone: initialFetchDone?.current || false,
  };
};

export default useFetchAuditFiles;
